import "core-js";
import "./polyfills/replace_children";

import smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill();
